import type { ReactNode } from 'react';
import { Box } from '@mantine/core';
import classes from './App.module.css';
import ImpersonationBanner from '@components/impersonation/ImpersonationBanner';
import TrialBanner from '@components/subscription/TrialBanner';
import AppUpdateBanner from '@components/app-update/AppUpdateBanner';
import DashboardHeader from '@components/dashboard-header/DashboardHeader';
import { useTheme } from '@contexts/ThemeContext';
import { useSidebar } from '@contexts/sidebar-context';

type AppMainProps = {
  children: ReactNode;
  /** Forwarded to the header's drawer toggle — see DashboardContent. */
  showMenuButton?: boolean;
  onMenuClick?: () => void;
};

const AppMain = ({ children, showMenuButton, onMenuClick }: AppMainProps) => {
  const { colors: themeColors } = useTheme();
  const { isHeaderVisible } = useSidebar();

  return (
    <Box
      className={classes.main}
      style={{
        backgroundColor: themeColors.background,
        minHeight: '100vh',
        width: '100%',
      }}
    >
      {/* Mounted here rather than per page so the bell is present on every
          dashboard screen. It floats now, so it takes no row of the page;
          full-viewport pages can still hide it via setIsHeaderVisible(false). */}
      {isHeaderVisible && <DashboardHeader showMenuButton={showMenuButton} onMenuClick={onMenuClick} />}
      <Box pt={showMenuButton && isHeaderVisible ? 64 : 'lg'} pb="lg" px="lg">
        <ImpersonationBanner />
        <TrialBanner />
        <AppUpdateBanner />
        {children}
      </Box>
    </Box>
  );
};

export default AppMain;
